import React, { useState } from 'react';
import { MenuIcon, XIcon, ShoppingBag } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
const navLinkStyle: React.CSSProperties = {
  color: '#2d5a1b',
  fontWeight: 600,
  fontSize: '14px',
  textDecoration: 'none',
  padding: '8px 4px',
  background: 'transparent',
  border: 'none',
  whiteSpace: 'nowrap',
  transition: 'color 0.2s'
};
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = ['Impacto'];
  const scrollToSection = (sectionId: string) => {
    const id = sectionId.toLowerCase();
    setMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      // wait for home to render before scrolling
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
      return;
    }
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <nav className="mp-navbar sticky top-0 left-0 right-0 z-50 flex items-center" style={{
      minHeight: '85px',
      background: '#ffffff',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      paddingLeft: '32px',
      paddingRight: '32px'
    }} data-id="element-183" data-mp="9qtybnyx19za">
        <div className="max-w-7xl mx-auto w-full" data-id="element-184" data-mp="3n3dwuvom3r4e">
          <div className="flex justify-between items-center" data-id="element-185" data-mp="3n4oximmrgira">
            <div className="flex-shrink-0" data-id="element-186" data-mp="3s278eikc981x">
              <Link to="/" data-id="element-187" data-mp="3s2ytgzgb7ndy">
                <img src="https://cdn.magicpatterns.com/uploads/5M6X1iYfRiLeS5bu5erw4R/3.png" alt="Pancita Feliz Foundation" className="mp-navbar-logo object-contain block" style={{
                width: '160px',
                height: 'auto',
                minWidth: '160px',
                marginRight: '32px',
                objectFit: 'contain'
              }} data-id="element-188" data-mp="3s049ta54e6ll" />
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-6" data-id="element-189" data-mp="2wcq6ycnyxi81">
              <Link to="/venezuela-emergencia" className="mp-nav-emg-link" style={{
              color: '#CC0000',
              fontWeight: 600,
              fontSize: '11px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 8px',
              borderRadius: '14px',
              border: '1.5px solid #CC0000',
              whiteSpace: 'nowrap',
              textDecoration: 'none',
              transition: 'all 0.2s'
            }} data-id="element-190" data-mp="2wacd2750yc22">
                <div style={{
                width: '8px',
                height: '8px',
                background: '#CC0000',
                borderRadius: '50%',
                animation: 'navPulse 1.5s infinite'
              }} data-id="element-191" data-mp="7juokzrjejck" />
                SOS Venezuela
              </Link>
              {menuItems.map(item => <button key={item} onClick={() => scrollToSection(item)} className="mp-nav-link" style={navLinkStyle} data-id="element-192" data-mp="14drimrc360l">
                  {item}
                </button>)}
              <Link to="/quiero-ser-aliado" className="mp-nav-link" style={navLinkStyle} data-id="element-193" data-mp="sxd0mp554011">
                Ser Aliado
              </Link>
              <Link to="/gala-2026" className="mp-nav-link" style={navLinkStyle} data-id="element-194" data-mp="k15hff1dsjdm">
                Gala 2026
              </Link>
              <Link to="/tienda" className="mp-nav-link" style={{
              ...navLinkStyle,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }} data-id="element-195" data-mp="1bs1k5mtq97n6">
                <ShoppingBag size={14} data-id="element-196" data-mp="3k1j4rmkv7gbm" />
                Tienda
              </Link>
              <Link to="/solicitar-ayuda" className="mp-nav-link" style={navLinkStyle} data-id="element-197" data-mp="3f49i2eov1irh">
                Solicitar Ayuda
              </Link>
              <Link to="/donar" className="bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-primary/90 transition-colors" data-id="element-198" data-mp="bmiyiiopbchg">
                Donar Ahora
              </Link>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-gray-100" aria-label="Toggle menu" data-id="element-199" data-mp="3u1jq1e2ao6ig">
              {mobileMenuOpen ? <XIcon className="h-6 w-6 text-dark" data-id="element-200" data-mp="pl8x62r65k7x" /> : <MenuIcon className="h-6 w-6 text-dark" data-id="element-201" data-mp="28alhgfil5wkt" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && <div className="md:hidden bg-white border-t absolute top-full left-0 right-0" data-id="element-202" data-mp="2dahj483t9bx7">
            <div className="px-4 py-4 space-y-3" data-id="element-203" data-mp="2hcchp4ucxb7a">
              <Link to="/venezuela-emergencia" onClick={() => setMobileMenuOpen(false)} style={{
            color: '#CC0000',
            fontWeight: 700,
            padding: '12px 16px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '15px',
            textDecoration: 'none'
          }} data-id="element-204" data-mp="2mae33wf99mlx">
                <div style={{
              width: '8px',
              height: '8px',
              background: '#CC0000',
              borderRadius: '50%',
              animation: 'navPulse 1.5s infinite'
            }} data-id="element-205" data-mp="3a0gt86zm0ihw" />
                SOS Venezuela
              </Link>
              {menuItems.map(item => <button key={item} onClick={() => scrollToSection(item)} className="block w-full text-left px-4 py-2 hover:bg-gray-50 rounded-lg" style={{
            ...navLinkStyle,
            fontSize: '15px'
          }} data-id="element-206" data-mp="1omc2bofn2ti9">
                  {item}
                </button>)}
              <Link to="/quiero-ser-aliado" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 hover:bg-gray-50 rounded-lg" style={{
            ...navLinkStyle,
            fontSize: '15px'
          }} data-id="element-207" data-mp="27jwhg3slqdpo">
                Ser Aliado
              </Link>
              <Link to="/gala-2026" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 hover:bg-gray-50 rounded-lg" style={{
            ...navLinkStyle,
            fontSize: '15px'
          }} data-id="element-208" data-mp="2jvyuehkubep8">
                Gala 2026
              </Link>
              <Link to="/tienda" onClick={() => setMobileMenuOpen(false)} className="px-4 py-2 hover:bg-gray-50 rounded-lg" style={{
            ...navLinkStyle,
            fontSize: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }} data-id="element-209" data-mp="213mrntq9ybek">
                <ShoppingBag size={16} data-id="element-210" data-mp="3ljrg5p0po7hl" />
                Tienda
              </Link>
              <Link to="/solicitar-ayuda" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 hover:bg-gray-50 rounded-lg" style={{
            ...navLinkStyle,
            fontSize: '15px'
          }} data-id="element-211" data-mp="3qjmak2jp3f7e">
                Solicitar Ayuda
              </Link>
              <Link to="/donar" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-primary/90 transition-colors" data-id="element-212" data-mp="1zl4fwtybwybz">
                Donar Ahora
              </Link>
            </div>
          </div>}
      </nav>
    </>;
}